// ============================================================
// Release / Version history — single source of truth
// ============================================================
// Newest release FIRST. The Releases page (src/views/Support/Releases.vue)
// renders this list top-to-bottom and highlights any component whose version
// CHANGED versus the next (older) entry.
//
// Version fields per release:
//   api  = mdf-bo-api        (Go backend)
//   bo   = mdf-bo-fn         (this repo — Vue 2 backoffice)
//   web  = mdf-www           (Next.js storefront)
//   app  = MadameFin Flutter (mobile app)
//
// IMPORTANT: only `bo` lives in THIS repo, so it is guarded against
// package.json (releases[0].components.bo MUST equal package.json version —
// enforced by scripts/check-release-version.js and
// tests/releases-version-matches-package.test.js). The api / app / web
// versions are CURATED by hand here because they live in other repos and
// cannot be read from this build — update them when cutting a release.
//
// Each fix links to https://github.com/asrth/mdf-project/issues/<issue>
// (mdf-umbrella was retired; all epics now track under asrth/mdf-project).

export const releases = [
    {
        date: "2026-07-13",
        components: {
            api: "2.8.173",
            bo: "1.0.0", // must match package.json (guarded)
            web: "0.1.73",
            app: "1.1.3",
        },
        fixes: [
            {
                issue: 345,
                component: "API+BO",
                title:
                    "Sync ทุกเส้นเป็น realtime: สินค้า storefront→BO, สถานะ order BO→เว็บสมาชิก, order เข้า BO, คูปอง — สะท้อนภายใน ~1-2 วินาที (sweep เดิมคงเป็นตัวเก็บตก)",
            },
            {
                issue: 349,
                component: "API",
                title:
                    "ปรับการตัดรอบส่งสินค้าไม่ให้กระทบรอบ marketplace ขนาดใหญ่",
            },
        ],
    },
    {
        date: "2026-07-13",
        components: {
            api: "2.8.172",
            bo: "1.0.0", // must match package.json (guarded)
            web: "0.1.73",
            app: "1.1.3",
        },
        fixes: [
            {
                issue: 339,
                component: "API",
                title:
                    "เปลี่ยนทิศ sync สินค้า: storefront → Backoffice ทางเดียว (สินค้า storefront เป็น platform MDFStore ใน BO) — หยุดดันสินค้า BO เข้า storefront",
            },
            {
                issue: 176,
                component: "BO",
                title:
                    'หน้าสินค้า App แสดงเฉพาะสินค้า storefront + ปุ่ม "ซิงก์ไป Backoffice" + สถานะเชื่อม WMS',
            },
            {
                issue: 338,
                component: "API",
                title:
                    "ล้างสินค้า marketplace ที่เคยปนใน storefront (1,599 รายการ)",
            },
            {
                issue: 339,
                component: "API",
                title:
                    "order MDFStore ตัดสต็อก WMS ผ่านการ map สินค้า platform MDFStore (staff ต้อง map SKU→WMS ที่หน้า สินค้า Platform)",
            },
            {
                issue: 180,
                component: "BO",
                title:
                    "หน้าสินค้า Platform เพิ่มตัวเลือก MDFStore + ปุ่มแก้ไขเพื่อ map SKU→WMS",
            },
        ],
    },
    {
        date: "2026-07-13",
        components: {
            api: "2.8.171",
            bo: "1.0.0", // must match package.json (guarded)
            web: "0.1.73",
            app: "1.1.3",
        },
        fixes: [
            {
                issue: 93,
                component: "API",
                title:
                    "แก้ราคา Flash Sale ไม่ถูกคิดตอนชำระเงินฝั่งเว็บสมาชิก (โชว์ราคาลดแต่เก็บเต็ม)",
            },
            {
                issue: 329,
                component: "API",
                title:
                    "สิทธิประโยชน์ระดับสมาชิก (ส่งฟรี/ส่วนลด%) มีผลจริงตอนชำระเงิน ทุกช่องทางรวม chat-order — ไม่ stack กับคูปอง (เลือกส่วนลดที่มากกว่า)",
            },
            {
                issue: 74,
                component: "API",
                title:
                    "Order ที่ยังไม่ชำระเงินจะไม่เข้า Backoffice จนกว่าจะจ่าย/ยืนยัน + สถานะชำระเงิน MDFStore ตรงกับช่องทางอื่น",
            },
            {
                issue: 77,
                component: "API",
                title:
                    "ราคาต่อชิ้นใน BO ตรงกับราคาที่เก็บจริง (รวมส่วนลด)",
            },
            {
                issue: 95,
                component: "API",
                title:
                    "รูปโปรไฟล์สมาชิกเสิร์ฟผ่าน CDN (อัปโหลดใหม่) — แอปเวอร์ชันเก่าใช้ได้เหมือนเดิม",
            },
            {
                component: "BO",
                title:
                    "แก้หน้าบัญชี (รายการบันทึก/หมวดหมู่) เปิดรายละเอียดไม่ได้",
            },
            {
                issue: 89,
                component: "WEB",
                title:
                    "แก้หน้า checkout/cart เว็บ โชว์ค่าส่งและยอดรวมตรงกับที่เรียกเก็บจริง (www 0.1.73)",
            },
        ],
    },
    {
        date: "2026-07-13",
        components: {
            api: "2.8.170",
            bo: "1.0.0", // must match package.json (guarded)
            web: "0.1.72",
            app: "1.1.3",
        },
        fixes: [
            {
                issue: 122,
                component: "API+BO",
                title:
                    "รายการสั่งซื้อ/ตรวจสอบการชำระเงิน แสดงออเดอร์ MDFStore โดยค่าเริ่มต้น (ตัวกรอง \"ทั้งหมด\" = มาดามฟิน + MDFStore) และค้นหาเจอแล้ว",
            },
            {
                issue: 273,
                component: "API",
                title:
                    "แก้ปุ่มเช็คสถานะขนส่งรายออเดอร์ (เดิมขึ้น \"Order ID not exists\" เสมอ)",
            },
            {
                issue: 272,
                component: "API",
                title:
                    "แก้ sync: outbox ไม่มาร์คส่งสำเร็จปลอมเมื่อโดน redirect และ productsync หยุด error ทุก 30 วินาที",
            },
            {
                component: "API",
                title:
                    "กันชื่อช่องทางการขายซ้ำระดับฐานข้อมูล (รองรับชื่อไทย)",
            },
            {
                component: "API",
                title:
                    "เพิ่มตารางใบกำกับภาษีฝั่งลูกค้า (แก้ปัญหา checkout ล้มเมื่อขอใบกำกับภาษี)",
            },
        ],
    },
    {
        date: "2026-07-12",
        components: {
            api: "2.8.169",
            bo: "1.0.0", // must match package.json (guarded)
            web: "0.1.72",
            app: "1.1.3",
        },
        fixes: [
            {
                issue: 315,
                component: "API+BO",
                title:
                    "ปิดใบสั่งขาย Modern Trade = สถานะสุดท้าย: ปิดแล้วแก้ไข/รับเงิน/ออกเอกสาร/ปรับสต็อกไม่ได้ทุกช่องทาง (รวมฝากขาย) — ดู/พิมพ์เอกสารได้ตามปกติ",
            },
            {
                issue: 317,
                component: "API+BO",
                title:
                    "ตารางข้อผิดพลาดตอนนำเข้ายอดขาย แสดงวันที่ขาย/จำนวน และแจ้งเมื่อรายการถูกตัด",
            },
            {
                issue: 163,
                component: "BO",
                title: "หน้าเทมเพลตราคาไม่เด้งข้อความผิดพลาดตอนเปิดหน้า",
            },
            {
                issue: 165,
                component: "BO",
                title:
                    "ตั้งค่ารูปแบบเอกสาร: ปรับให้ตรงกับเอกสารจริงแต่ละชนิด",
            },
            {
                issue: 317,
                component: "API",
                title: "แก้ URL เชื่อมต่อ LINE ที่ส่ง scope/nonce ไม่ถูกต้อง",
            },
            {
                issue: 317,
                component: "API",
                title: "ปรับปรุงชุดทดสอบภายใน (go test ./... กลับมาใช้งานได้)",
            },
        ],
    },
    {
        date: "2026-07-12",
        components: {
            api: "2.8.168",
            bo: "1.0.0", // must match package.json (guarded)
            web: "0.1.72",
            app: "1.1.3",
        },
        fixes: [
            {
                issue: 303,
                component: "API+BO",
                title:
                    "เพิ่มการปิดใบรายการขาย Modern Trade (ส่งของแล้ว → ปิดใบ)",
            },
            {
                issue: 153,
                component: "BO",
                title:
                    "แก้เทมเพลตราคา MT ใช้งานได้ (รายการสินค้าไม่ขึ้นใน dropdown) + ปรับตาราง 50/50",
            },
            {
                issue: 304,
                component: "API",
                title:
                    "ปรับใบกำกับภาษี: ตารางไม่ทับหัวเอกสาร, รวมคอลัมน์รหัส-รายการสินค้า, เส้นเซ็นแยก 3 เส้น",
            },
            {
                issue: 307,
                component: "API+BO",
                title:
                    "กันบันทึกรับเงินเกินยอดคงค้าง (แสดงยอดคงค้างจริงตอนส่งของบางส่วน)",
            },
            {
                issue: 306,
                component: "API+BO",
                title:
                    "ไฟล์นำเข้ารายการขายรองรับเฉพาะ SKU และบาร์โค้ด + แสดงข้อผิดพลาดรายแถว",
            },
            {
                issue: 156,
                component: "BO",
                title:
                    "ปรับคอลัมน์สถานะใบกำกับภาษี และคอลัมน์แหล่งที่มา ให้อ่านง่ายขึ้น",
            },
        ],
    },
    {
        date: "2026-07-11",
        components: {
            api: "2.8.167",
            bo: "1.0.0", // must match package.json (guarded)
            web: "0.1.72",
            app: "1.1.3",
        },
        fixes: [
            {
                issue: 198,
                component: "API+Web+Member",
                title:
                    "แก้จ่ายเงินบัตรแล้ว redirect กลับหน้า result ไม่ได้ (405)",
            },
            {
                issue: 198,
                component: "Web+Member",
                title:
                    "Timeline สถานะแนวตั้งเรียงรายการล่าสุดไว้บนสุด (เว็บร้านค้า+ระบบสมาชิก)",
            },
            {
                issue: 198,
                component: "Web+Member",
                title:
                    "แก้ลำดับ timeline กรณีเวลาเท่ากัน ให้สถานะปลายทาง (จัดส่งสำเร็จ/ตีกลับ) ขึ้นบนสุด (www 0.1.72 + member)",
            },
            {
                component: "BO",
                title:
                    "ปรับ modal ทุกหน้า: มุมโค้ง + เส้นคั่น header/footer",
            },
            {
                issue: 200,
                component: "API+BO",
                title:
                    "Modern Trade: popup รายละเอียดสินค้าแสดงชื่อ WMS / SKU / บาร์โค้ด",
            },
            {
                issue: 189,
                component: "API+BO",
                title:
                    "ตั้งค่าอัตราคะแนนสะสม (คะแนนต่อยอดซื้อ 100 บาท คิดตามยอดจริง) ได้ในหน้าตั้งค่าหน้าร้าน",
            },
            {
                issue: 189,
                component: "Web+Member",
                title:
                    "หน้าระดับสมาชิกกลับมาแสดงข้อมูลและสิทธิ์พิเศษของแต่ละระดับ (ฟรีค่าจัดส่ง / ส่วนลด % ต่อระดับ)",
            },
            {
                issue: 189,
                component: "BO",
                title:
                    "ตั้งค่าการแสดงเมนูส่วนตัว: ซ่อนหรือปักหมุดเมนู sidebar ได้เองต่อผู้ใช้ (ปุ่มตั้งค่าเมนูในหน้าโปรไฟล์)",
            },
            {
                issue: 189,
                component: "Member",
                title:
                    "บัตรสมาชิก: แสดงยอดสะสมและระดับถัดไปถูกต้อง พร้อมปิดบังเบอร์โทรศัพท์ (แตะเพื่อดู)",
            },
            {
                issue: 189,
                component: "Web+Member",
                title:
                    "Timeline คำสั่งซื้อรูปแบบใหม่ทั้งเว็บร้านค้าและระบบสมาชิก (บัตรสมาชิก / เก็บเงินปลายทาง / ยกเลิก / ตีกลับ)",
            },
            {
                issue: 189,
                component: "BO",
                title:
                    "เมนูปักหมุดแสดงเมนูย่อยครบ (พับ/กางได้เหมือนตำแหน่งปกติ)",
            },
            {
                issue: 200,
                component: "API+BO",
                title:
                    "Modern Trade: แสดงชื่อสินค้าในคลัง/ใบสั่งซื้อ + เตือนสินค้าที่ยังไม่มีรหัส SKU ตอนสร้างใบสั่งซื้อ",
            },
        ],
    },
    {
        date: "2026-07-10",
        components: {
            api: "2.8.163",
            bo: "1.0.0", // must match package.json (guarded)
            web: "0.1.67",
            app: "1.1.3",
        },
        fixes: [
            {
                issue: 189,
                component: "API+BO",
                title:
                    "คำสั่งซื้อเก็บเงินปลายทาง (COD) ยืนยันทันทีหลังสั่งซื้อ (เตรียมส่งสินค้า) ส่งตรงเข้า Backoffice โดยไม่ต้องตรวจสอบการชำระเงิน",
            },
            {
                issue: 189,
                component: "API+BO",
                title:
                    "ลูกค้ายกเลิกคำสั่งซื้อ COD ได้เองก่อนตัดรอบส่งสินค้า (ทั้งเว็บร้านค้าและระบบสมาชิก) พร้อม sync สถานะยกเลิกเข้า Backoffice อัตโนมัติ",
            },
            {
                issue: 189,
                component: "API+BO",
                title:
                    "ตั้งค่า “ช่องทางการขาย MDFStore” (เว็บร้านค้า/ระบบสมาชิก/แอปพลิเคชัน) ในหน้าตั้งค่าหน้าร้าน — คำสั่งซื้อที่ sync เข้า Backoffice จะระบุช่องทางตามที่เลือก",
            },
            {
                issue: 189,
                component: "Web",
                title:
                    "แสดงคะแนนสะสมและยอดใช้จ่ายสะสมบนเว็บร้านค้า (www) แล้ว",
            },
            {
                issue: 189,
                component: "Web+BO",
                title:
                    "ปรับ UI: ตัวเลือกสินค้าที่ไม่มีรูปแสดงเฉพาะชื่อ, เลขบัตรสมาชิกเป็นสีขาว, เปลี่ยนชื่อแท็บคำสั่งซื้อของร้านค้า และปรับแท็บ Modern Trade เป็นพื้นหลังสีขาว",
            },
        ],
    },
    {
        date: "2026-07-10",
        components: {
            api: "2.8.161",
            bo: "1.0.0", // must match package.json (guarded)
            web: "0.1.65",
            app: "1.1.3",
        },
        fixes: [
            {
                issue: 189,
                component: "API+BO",
                title:
                    "เพิ่มช่องทาง MDFStore: คำสั่งซื้อจากเว็บ/แอป/สมาชิก sync เข้า Backoffice อัตโนมัติ เริ่มที่สถานะ “รอตัดรอบส่งสินค้า” (เก็บเงินปลายทางเริ่มที่รอชำระเงินให้เจ้าหน้าที่ยืนยัน)",
            },
            {
                issue: 189,
                component: "API+BO",
                title:
                    "เลขคำสั่งซื้อของลูกค้าใช้รูปแบบใหม่ yyMMdd ตามด้วยรหัส 8 ตัวอักษร (เช่น 2607102DDA6C2E) ตรงกันทุกช่องทาง พร้อมเติมเลขให้คำสั่งซื้อเดิม",
            },
            {
                issue: 189,
                component: "API+BO",
                title:
                    "เปิดใช้งาน Order Sync ระหว่างแอปกับ Backoffice ครั้งแรก (mirror สถานะสองทาง + บันทึกคะแนนสะสมอัตโนมัติเมื่อคำสั่งซื้อสำเร็จ)",
            },
            {
                issue: 189,
                component: "BO",
                title:
                    "ปุ่มจำลองสถานะจัดส่ง (เฉพาะ staging): จัดส่งสำเร็จ/ไม่สำเร็จ/ตีกลับ สำหรับคำสั่งซื้อ MDFStore เพื่อทดสอบครบวงจร",
            },
            {
                issue: 189,
                component: "BO",
                title:
                    "เพิ่มตัวกรองช่องทาง “MDFStore” ในหน้ารายการสั่งซื้อ ตรวจสอบการชำระเงิน และคูปอง",
            },
            {
                issue: 189,
                component: "API+BO",
                title:
                    "แก้ไข: ยืนยันการชำระเงินคำสั่งซื้อ MDFStore ได้โดยไม่ต้องเลือกช่องทาง BO, ปุ่มจำลองอ่านรหัสคำสั่งซื้อถูกต้อง, และ ingest รองรับเก็บเงินปลายทางที่ยังไม่ชำระ",
            },
        ],
    },
    {
        date: "2026-07-09",
        components: {
            api: "2.8.156",
            bo: "1.0.0", // must match package.json (guarded)
            web: "0.1.65",
            app: "1.1.3",
        },
        fixes: [
            {
                issue: 189,
                component: "API+BO",
                title:
                    "คำสั่งซื้อจากเว็บ/แอปแสดงเป็นร้าน MDFStore แยกชัดเจน + ปุ่มจำลองการจัดส่ง (สำเร็จ/ไม่สำเร็จ/ตีกลับ) บน staging สำหรับทดสอบครบวงจรรวมคะแนนสะสม",
            },
        ],
    },
    {
        date: "2026-07-09",
        components: {
            api: "2.8.155",
            bo: "1.0.0", // must match package.json (guarded)
            web: "0.1.65",
            app: "1.1.3",
        },
        fixes: [
            {
                issue: 187,
                component: "API+WEB",
                title:
                    "แก้บันทึกข้อมูลส่วนตัวไม่ได้ (invalid body), เชื่อมต่อ LINE ใหม่ได้หลังยกเลิก, แก้เพศแสดงผิดบน storefront",
            },
            {
                issue: 188,
                component: "WEB",
                title:
                    "บัตรสมาชิกพลิกดู QR/บาร์โค้ดได้, เมนูเปลี่ยนรูปแบบใหม่ (อัปโหลด/LINE/Google), จัดหน้าโปรไฟล์ใหม่, ถอดรหัสสมาชิกออก",
            },
        ],
    },
    {
        date: "2026-07-09",
        components: {
            api: "2.8.154",
            bo: "1.0.0", // must match package.json (guarded)
            web: "0.1.63",
            app: "1.1.3",
        },
        fixes: [
            {
                issue: 183,
                component: "BO",
                title:
                    "Modern Trade: กด PDF เปิดหน้าตัวอย่างเอกสารพร้อมพิมพ์ (เลือกเอกสารพิมพ์รวมชุดเดียว ต้นฉบับ/สำเนา + จำนวนชุด)",
            },
            {
                issue: 179,
                component: "API+BO",
                title:
                    "เก็บเงินปลายทาง: นับการปฏิเสธรับสินค้าต่อเบอร์ บล็อกอัตโนมัติเมื่อถึงเกณฑ์ (ตั้งค่าได้) พร้อมหน้าแอดมินดู/ปลดบล็อก",
            },
        ],
    },
    {
        date: "2026-07-09",
        components: {
            api: "2.8.152",
            bo: "1.0.0", // must match package.json (guarded)
            web: "0.1.63",
            app: "1.1.3",
        },
        fixes: [
            {
                issue: 185,
                component: "WEB",
                title:
                    "มือถือ: แถบบนเหลือโลโก้/ค้นหา/รูปโปรไฟล์ เมนูที่เหลือย้ายเข้าเมนูโปรไฟล์",
            },
            {
                issue: 185,
                component: "WEB",
                title:
                    "หน้าโปรไฟล์: ชื่อ-สกุลนำหน้าเบอร์โทร, วันเกิดแสดงเป็นข้อความ (พ.ศ./ค.ศ. ตามภาษา), แก้ปฏิทินวันเกิดโดนบังกดไม่ได้",
            },
            {
                issue: 186,
                component: "API+WEB",
                title:
                    "ยกเลิกการเชื่อมต่อ LINE/อีเมลได้เอง พร้อมกันไม่ให้หลุดจนไม่เหลือช่องทางเข้าสู่ระบบ",
            },
        ],
    },
    {
        date: "2026-07-09",
        components: {
            api: "2.8.151",
            bo: "1.0.0", // must match package.json (guarded)
            web: "0.1.62",
            app: "1.1.3",
        },
        fixes: [
            {
                issue: 182,
                component: "API+WEB",
                title:
                    "รูปโปรไฟล์เป็นรูปเดียวกันทุกช่องทาง (เว็บสมาชิก/หน้าร้าน/แอป), ปุ่ม 'ใช้รูปจาก LINE' ใช้งานได้จริงโดยใช้รูปจาก LINE โดยตรง, หน้าร้านแสดงรูปโปรไฟล์แล้ว, แสดงบัญชี LINE ที่เชื่อมต่อ",
            },
            {
                issue: 182,
                component: "API",
                title:
                    "อัปเดตชื่อและรูป LINE อัตโนมัติทุกครั้งที่เข้าสู่ระบบด้วย LINE",
            },
        ],
    },
    {
        date: "2026-07-09",
        components: {
            api: "2.8.149",
            bo: "1.0.0", // must match package.json (guarded)
            web: "0.1.61",
            app: "1.1.3",
        },
        fixes: [
            {
                issue: 180,
                component: "API",
                title:
                    "เสริมความปลอดภัย OTP: จำกัดความถี่การขอรหัสครบทุกช่องทาง, เพดานจำนวน SMS ต่อวันทั้งระบบ (ตั้งค่าได้), ป้องกันการล็อกเบอร์ผู้อื่น",
            },
            {
                issue: 180,
                component: "BO",
                title:
                    "เพิ่มการตั้งค่าเพดาน SMS OTP ต่อวันในหน้าตั้งค่า Storefront",
            },
        ],
    },
    {
        date: "2026-07-09",
        components: {
            api: "2.8.148",
            bo: "1.0.0", // must match package.json (guarded)
            web: "0.1.61",
            app: "1.1.3",
        },
        fixes: [
            {
                issue: 181,
                component: "API+BO",
                title:
                    "จำกัดจำนวนคำสั่งซื้อเก็บเงินปลายทาง (COD) ที่ค้างอยู่พร้อมกันต่อสมาชิก/เบอร์โทร — ตั้งค่าได้ในหน้าตั้งค่า Storefront (ค่าเริ่มต้น 3) กันการสั่งมั่วไม่รับของ",
            },
            {
                issue: 181,
                component: "WEB",
                title:
                    "หน้า checkout แสดงข้อความแจ้งเหตุผลจริงเมื่อถูกจำกัดการสั่ง COD",
            },
            {
                issue: 176,
                component: "API",
                title:
                    "รหัส OTP โหมดทดสอบเป็น 6 หลักให้ตรงกับระบบจริง",
            },
        ],
    },
    {
        date: "2026-07-09",
        components: {
            api: "2.8.147",
            bo: "1.0.0", // must match package.json (guarded)
            web: "0.1.61",
            app: "1.1.3",
        },
        fixes: [
            {
                issue: 176,
                component: "API+WEB",
                title:
                    "ยืนยันเบอร์โทรด้วย OTP ใช้งานได้จริง: ส่ง SMS ผ่านระบบ OTP ของ ThaiBulkSMS (รหัส 6 หลัก + Refcode + นับถอยหลัง 5 นาที ขอซ้ำได้รหัสอ้างอิงเดิม)",
            },
            {
                issue: 176,
                component: "API+WEB",
                title:
                    "เพิ่มการยืนยันตัวตน (Cloudflare Turnstile) ก่อนส่ง OTP ทุกครั้งบนเว็บ storefront และ member — กันบอทยิง SMS",
            },
            {
                component: "WEB",
                title:
                    "แก้ช่องกรอก OTP รองรับ 6 หลัก (หน้าโปรไฟล์/สมัครสมาชิก member)",
            },
        ],
    },
    {
        date: "2026-07-08",
        components: {
            api: "2.8.146",
            bo: "1.0.0", // must match package.json (guarded)
            web: "0.1.60",
            app: "1.1.3",
        },
        fixes: [
            {
                issue: 174,
                component: "WEB",
                title:
                    "สมาชิก — จัดระเบียบหน้าโปรไฟล์ (ถอดรหัสสมาชิก/ชื่อเล่น/ตลาด), แสดงวันที่เป็น พ.ศ., ปุ่มใช้รูปจาก LINE แสดงเฉพาะผู้ที่เชื่อม LINE, การ์ดสมาชิกหน้าหลักเรียบขึ้น + ไอคอนเมนูสีทองทั้งชุด",
            },
            {
                issue: 175,
                component: "API",
                title:
                    "สมาชิก — แก้รายการสินค้าในรายละเอียดคำสั่งซื้อไม่แสดงรูป (เติมการซ่อมรูปอัตโนมัติให้ครบทุกจุด)",
            },
            {
                issue: 176,
                component: "API+WEB",
                title:
                    "ชำระเงินจากหน้า member แล้วกลับมาที่ member ถูกต้อง (return URL แยกตาม surface + กันลิงก์ปลอม)",
            },
            {
                issue: 177,
                component: "API+WEB",
                title:
                    "เลขที่คำสั่งซื้อรูปแบบใหม่ yymmdd+รหัส (เช่น 2607086084) แสดงตรงกันทุกช่องทาง (เว็บ/สมาชิก/แอป) รวมคำสั่งซื้อเก่า",
            },
            {
                issue: 178,
                component: "API",
                title:
                    "แก้หน้า checkout แสดงราคาไม่ตรงกับยอดที่ตัดจริง (ราคาต่อ SKU ถูก reprice ผิด)",
            },
            {
                component: "WEB",
                title:
                    "ปรับฟอนต์ทั้ง storefront และ member เป็น Google Font ‘Kanit’ ทั้งหมด",
            },
        ],
    },
    {
        date: "2026-07-08",
        components: {
            api: "2.8.143",
            bo: "1.0.0", // must match package.json (guarded)
            web: "0.1.58",
            app: "1.1.3",
        },
        fixes: [
            {
                issue: 162,
                component: "BO",
                title:
                    "Modern Trade — ย้ายเมนู ‘คลังสินค้า MT’ ไปไว้ใต้ ‘ใบกำกับภาษี’",
            },
            {
                issue: 163,
                component: "API+BO",
                title:
                    "หน้า ‘ข้อมูลการขาย’ — แสดงรายการที่บันทึกไว้ + นำเข้าโดยเลือกบริษัทจาก dropdown (เลิกอ่าน tax_id จากไฟล์), รองรับสาขา (default 00000), ระบุ lot เพื่อตัดตรง lot, และบันทึกการขายเองพร้อม dropdown lot ที่แสดงยอดคงเหลือ/FEFO",
            },
            {
                issue: 164,
                component: "API+BO",
                title:
                    "ใบสั่งซื้อ — เพิ่มวันที่ PO, คอลัมน์ลูกค้า+เลขภาษี/สาขา, ค้นหาตามวันที่สร้าง, กลับมาที่ผลค้นหาเดิม, ดู PDF เต็มจอ, จัดรายละเอียดเป็น 3 แท็บ, ปรับสีสถานะเป็นโทนสว่าง",
            },
            {
                issue: 165,
                component: "BO",
                title:
                    "ใบกำกับภาษี — ย้ายปุ่มค้นหาไปท้ายตัวกรอง + ดู PDF เต็มจอ",
            },
            {
                issue: 166,
                component: "API+BO",
                title:
                    "ตั้งค่ารูปแบบเอกสาร — ปรับสี/โลโก้/ตรายาง/ชื่อฟิลด์-คอลัมน์/หมายเหตุ/ลายเซ็น มีผลกับ PDF ใบสั่งผลิต ใบส่งของ และใบกำกับภาษี",
            },
            {
                issue: 167,
                component: "API+WEB",
                title:
                    "คำสั่งซื้อของฉัน (เว็บ+member) — รวมสถานะช่วงเตรียมจัดส่งเป็น ‘เตรียมส่งสินค้า’, ไทม์ไลน์แนวนอน, รวมการ์ดรายการ+ยอดเป็นใบเดียว, แสดงที่อยู่จัดส่ง + ไทม์ไลน์ขนส่ง",
            },
            {
                issue: 168,
                component: "API+WEB",
                title:
                    "บัญชีของฉัน — รูปโปรไฟล์ถาวร + ใช้รูปจาก LINE, ยืนยันเบอร์พร้อม Refcode และนับถอยหลัง 5 นาที (ขอซ้ำได้ ref เดิม), ปฏิทินเลือกวันเกิด, ปิดเบอร์เหลือ 4 ตัวท้าย, เมนูบัญชีมีปุ่มออกจากระบบ",
            },
            {
                issue: 169,
                component: "API+BO+WEB",
                title:
                    "ระบบแจ้งเตือน — แจ้งอัพเดตคำสั่งซื้อ (มีรูปสินค้า กดไปหน้าออเดอร์) + แจ้งโปรโมชันจาก BO (broadcast) + กระดิ่ง/หน้าแจ้งเตือนบนเว็บ",
            },
            {
                component: "WEB",
                title:
                    "คูปอง — ลิงก์เก็บโค้ดพาไปหน้าคูปองพร้อมเติมโค้ดให้อัตโนมัติ (?code=)",
            },
        ],
    },
    {
        date: "2026-07-08",
        components: {
            api: "2.8.142",
            bo: "1.0.0", // must match package.json (guarded)
            web: "0.1.56",
            app: "1.1.3",
        },
        fixes: [
            {
                issue: 154,
                component: "API+BO",
                title:
                    "Modern Trade — บันทึกรับเงินที่ใบสั่งซื้อ (SO) แล้วออกใบกำกับภาษีอัตโนมัติเต็มยอดที่ส่งของ (รองรับชำระบางส่วน); ถอดแท็บ ‘รอออกใบ/สินค้าค้างวางบิล’ ออก",
            },
            {
                component: "BO",
                title:
                    "Modern Trade — เลือกผู้ผลิตจาก ‘บริษัทผู้ผลิต’ (wms partner), แสดง SKU เป็น man_pn, จัดการ ‘กลุ่มสินค้า’ (category master) + เลือกจาก dropdown; เปลี่ยนป้าย wms partner เป็นบริษัทผู้ผลิต",
            },
            {
                component: "BO",
                title:
                    "Modern Trade — จัดกลุ่มเมนู (ตั้งค่า: สินค้า/เทมเพลตราคา/บริษัทคู่ค้า · รายงาน: ยอดขาย/มูลค่าคงเหลือ/วันหมดอายุ/คลัง MT), เปลี่ยน ‘ใบขาย’ → ‘ใบสั่งซื้อ (PO)’, ช่องเลือกในหน้าสร้างเป็น dropdown, ถอดเมนูใบรับสินค้า",
            },
            {
                component: "BO",
                title:
                    "Modern Trade — ตารางรายการสินค้า/ใบสั่งผลิต/ใบส่งของ ขยายเต็มขอบชิดหัวการ์ด, ซ่อนปุ่มสร้างใบสั่งผลิต/ใบส่งของเมื่อมีเอกสารแล้ว",
            },
            {
                component: "BO",
                title:
                    "Modern Trade — SKU dropdown ใช้ endpoint wms-product-options ที่เบา (WmsProductListV3 timeout บนข้อมูลจริง)",
            },
            {
                component: "API",
                title:
                    "ตะกร้าสินค้า (www/member) — ซ่อมรูปที่หายให้อัตโนมัติตอนอ่านตะกร้า ทั้งชุดโปรโมชันและสินค้าเดี่ยว (heal-on-read)",
            },
            {
                component: "BO",
                title:
                    "แก้ป็อปอัป error (sweetalert2) โผล่หลัง Element UI dialog ทำให้มองไม่เห็น — ยกระดับ z-index; แก้ปุ่มยืนยัน swal ไม่ทำงาน (v9 ใช้ result.value)",
            },
        ],
    },
    {
        date: "2026-07-07",
        components: {
            api: "2.8.138",
            bo: "1.0.0",
            web: "0.1.56",
            app: "1.1.3",
        },
        fixes: [
            {
                issue: 128,
                component: "API+BO",
                title:
                    "Modern Trade v2 — สร้างโมดูลใหม่: ข้อมูลสินค้า MT, เทมเพลตราคาผูกบริษัทคู่ค้า (VAT-included/GP%/เครดิตเทอม), เอ็นจินคำนวณราคา (ปลีกรวม VAT × (1−GP%) ÷ 1.07)",
            },
            {
                issue: 135,
                component: "API+BO",
                title:
                    "Modern Trade v2 — วงจรใบสั่งซื้อ (สร้าง/ยืนยัน/ยกเลิก + แนบไฟล์ PO), ใบสั่งผลิต (แยกใบต่อผู้ผลิต + PDF + Excel Lot/Expire), นำเข้า Lot/หมดอายุ",
            },
            {
                issue: 138,
                component: "API+BO",
                title:
                    "Modern Trade v2 — ใบส่งของ (DO + PDF) + สร้าง BO Order ราคา 0 อัตโนมัติ, คุมยอดส่งสะสมข้ามใบ, ล็อกใบสั่งซื้อกันแข่งกันในทรานแซกชัน",
            },
            {
                issue: 140,
                component: "API+BO",
                title:
                    "Modern Trade v2 — ใบกำกับภาษี (2 แหล่งที่มา) + PDF เลย์เอาต์ IV6 + ThaiBahtText, บันทึกชำระเงินบางส่วน, เลขเอกสารรันต่อวันแบบ atomic",
            },
            {
                issue: 142,
                component: "API+BO",
                title:
                    "Modern Trade v2 — รายงานยอดขาย (สรุป + รายละเอียด + export xlsx) และรายงานมูลค่าคงเหลือ (แยกตามบริษัท ถอด VAT + หัก GP)",
            },
            {
                issue: 124,
                component: "API+BO",
                title:
                    "ระบบแจ้งปัญหาในแอป (Issue Reporting) — ฟอร์มแจ้ง + รายการของฉัน, sync ขึ้น GitHub ทันที + ปุ่ม Sync now, แนบภาพได้ถึง 10 รูป, หน้าประวัติเวอร์ชัน (Releases)",
            },
            {
                issue: 126,
                component: "API+WEB",
                title:
                    "โปรโมชัน — รูปหลักของโปรโมชันชนะเสมอบนภาพหน้าปกการ์ด (แก้ list ไม่โหลด gallery)",
            },
        ],
    },
    {
        date: "2026-07-07",
        components: {
            api: "2.8.131",
            bo: "1.0.0",
            web: "0.1.56",
            app: "1.1.3",
        },
        fixes: [
            {
                component: "API",
                title:
                    "TikTok — ซิงก์ออเดอร์ที่ถูกยกเลิกล่าช้าด้วยการไล่รอบสองตาม update_time (auto AwaitingShipment → Cancelled); แก้ deadlock ตัวซิงก์ 3 รอบ",
            },
            {
                component: "API",
                title:
                    "Shopee — ซิงก์การยกเลิกล่าช้าตาม update_time + ประมวลผลสถานะ CANCELLED (แยกตัวช่วย classify/dedupe ที่มีเทสต์)",
            },
            {
                component: "API+BO",
                title:
                    "หน้า Sync Log — ประวัติงานซิงก์แพลตฟอร์ม (GET /platform/v2/sync/jobs) + ไทม์ไลน์สถานะออเดอร์ (bo_order_status_log)",
            },
            {
                component: "API",
                title:
                    "WMS — เลิกประทับเวลาแบบ literal-Z (UTC) บน created_at ของใบจัดสินค้า ใช้ค่าเวลาจริง",
            },
            {
                component: "BO",
                title: "Seller — แสดงรหัสไปรษณีย์ผู้รับในหน้ารายละเอียดออเดอร์",
            },
        ],
    },
];

export default releases;
